

export class TutorDisponibilidad{    
  idTutorDisponibilidad:number;
  idTutor:number;
  nombreTutor:string;
  rutTutor:string;
  fechaInicio:Date;
  fechaFin:Date;
  idEstado:number;
  rbdJardin:number;
  nombreJardin : String;
  constructor(){
      this.idTutorDisponibilidad = 0;
      this.idTutor = 0;
      this.nombreTutor="";
      this.rutTutor="";
      this.fechaInicio = new Date();
      this.fechaFin = new Date();
      this.idEstado = 0;
      this.rbdJardin = 0;
      this.nombreJardin = "";
  }
}

export class ResponseAllTutorDisponibilidades{
  payload:TutorDisponibilidad[];

    constructor(){
        this.payload = new Array<TutorDisponibilidad>();
    }
}

export class ResponseTutorDisponibilidad{
  
  payload:number;

  constructor(){
      this.payload = 0;
  }
}

export class ResponseTutorDisponibilidadObject{
  
  payload:TutorDisponibilidad;

  constructor(){
      this.payload = new TutorDisponibilidad();
  }
}